import { Module } from "@7egend/dxp-web-core/lib/bootstrap"
import loadable from "@loadable/component"

/**
 * Notifications inbox — DXP area. See docs/notifications.md, "Step 5b".
 */
export const notificationsSetup: Module = {
	routes: [
		// Notifications List
		{
			component: loadable(
				async () => (await import("./Notifications")).Notifications
			),
			path: "footlab/notifications",
			exact: true,
		},
		// Automatic notifications (read-only, rule switches) — before the generic routes below
		{
			component: loadable(
				async () => (await import("./NotificationsAutomatic")).NotificationsAutomatic
			),
			path: "/footlab/notifications/automatic",
		},
		// Notifications Create
		{
			component: loadable(
				async () => (await import("./NotificationsEditor")).NotificationsEditor
			),
			path: "/footlab/notifications/add",
		},
		// Notifications Update / View
		{
			component: loadable(
				async () => (await import("./NotificationsEditor")).NotificationsEditor
			),
			path: "/footlab/notifications/edit/:id",
		},
	],
	menus: [
		{
			title: {
				key: "footlab.notifications.menu.title",
				en: "Notifications",
				es: "Notificaciones",
				pt: "Notificações",
			},
			path: "footlab/notifications",
			permission: "footlab.notifications.list",
			children: [
				{
					title: {
						key: "footlab.notifications.edit.menu.title",
						en: "Edit notification",
						es: "Editar notificación",
						pt: "Editar notificação",
					},
					path: "footlab/notifications/edit",
					visible: false,
					permission: "footlab.notifications.edit",
				},
			],
		},
		// A sibling, not a child of "Notifications": the sidebar only renders translated
		// titles ({key, en, es, pt}) on the first two levels.
		{
			title: {
				key: "footlab.notifications.automatic.menu.title",
				en: "Automatic notifications",
				es: "Notificaciones automáticas",
				pt: "Notificações automáticas",
			},
			path: "footlab/notifications/automatic",
			permission: "footlab.notifications.edit",
		},
	],
}
